import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function DepositCash({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M11.3333 8.00001C11.3333 9.10458 10.4378 10 9.33325 10C8.22868 10 7.33325 9.10458 7.33325 8.00001C7.33325 6.89544 8.22868 6.00001 9.33325 6.00001C10.4378 6.00001 11.3333 6.89544 11.3333 8.00001Z"
        fill={iconColor}
      />
      <Path
        d="M1.33325 4.00001C1.33325 3.63182 1.63173 3.33334 1.99992 3.33334H16.6666C17.0348 3.33334 17.3333 3.63182 17.3333 4.00001V12C17.3333 12.3682 17.0348 12.6667 16.6666 12.6667H1.99992C1.63173 12.6667 1.33325 12.3682 1.33325 12V4.00001ZM2.66659 4.66668V11.3333H15.9999V4.66668H2.66659Z"
        fill={iconColor}
      />
      <Path
        d="M6.66659 20V14H7.99992V19.3333H21.3333V12.6667H18.6666V11.3333H21.9999C22.3681 11.3333 22.6666 11.6318 22.6666 12V20C22.6666 20.3682 22.3681 20.6667 21.9999 20.6667H7.33325C6.96506 20.6667 6.66659 20.3682 6.66659 20Z"
        fill={iconColor}
      />
      <Path
        d="M12.6666 16C12.6666 14.8954 13.562 14 14.6666 14C15.7712 14 16.6666 14.8954 16.6666 16C16.6666 17.1046 15.7712 18 14.6666 18C13.562 18 12.6666 17.1046 12.6666 16Z"
        fill={iconColor}
      />
    </Svg>
  );
}
